<template>
  <Wrapper>
    <Grid>
      <Header>
        <Logo class="forHome" />
      </Header>
      <Nav />
    </Grid>
    <Intro />
    <Features />
    <Finest />
    <Timeline />
    <Engagements />
    <Contact />
    <Footer />
    <!-- <div class="grid-column x1">2</div>
        <div class="grid-column x1">3</div>
        <div class="grid-column x1">4</div>
        <div class="grid-column x1">5</div>
        <div class="grid-column x1">6</div>
        <div class="grid-column x1">7</div>
    <div class="grid-column x1">8</div>-->
  </Wrapper>
</template>
<script>
import Wrapper from "./Wrapper.vue";
import Grid from "./Grid.vue";
import Header from "./Header.vue";
import Nav from "./Nav.vue";
import Intro from "./Section.Intro.vue";
import Features from "./Section.Features.vue";
import Finest from "./Section.Finest.vue";
import Timeline from "./Section.Timeline.vue";
import Engagements from "./Section.Engagements.vue";
import Contact from "./Section.Contact.vue";
import Footer from "./Footer.vue";
import Logo from "./Logo.vue";

export default {
  name: "Home",
  components: {
    Wrapper,
    Grid,
    Header,
    Nav,
    Intro,
    Features,
    Finest,
    Timeline,
    Engagements,
    Contact,
    Footer,
    Logo
  }
};
</script>
<style>
@media only screen and (max-width: 576px) {
  header .logo.forHome {
    --left: auto;
    --right: 0;
    --bottom: calc(var(--LINE-HEIGHT) / 2);
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  header .logo.forHome {
    --left: 0;
    --right: auto;
    --bottom: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
  header .logo.forHome {
    --left: 0;
    --right: auto;
    --bottom: 0;
  }
}
@media only screen and (min-width: 992px) {
  header .logo.forHome {
    --left: -24px;
    --right: auto;
    --bottom: 0;
  }
}

.logo.forHome {
  position: absolute !important;
  bottom: var(--bottom);
  right: var(--right);
  left: var(--left);
}

section.forHome {
  padding-top: calc(var(--LINE-HEIGHT) * 3);
  min-height: 100vh;
  overflow: hidden;
  padding-bottom: calc(var(--LINE-HEIGHT) * 3);
  /* outline: 2px orange solid; */
  max-height: 1024px;
}

.grid.forHome {
  min-height: 100vh;
}

@media only screen and (max-width: 576px) {
  section.forHome,
  .grid.forHome {
    min-height: calc(var(--vh) * 100);
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  section.forHome,
  .grid.forHome {
    min-height: calc(var(--vh) * 100);
  }
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
}
@media only screen and (min-width: 992px) {
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue